<template>
    <div id="blog-post-page">
        <div v-if="error" class="container mtb-80">
            <app-back :title="error"></app-back>
        </div>

        <section class="hero is-info is-medium is-bold">
            <div class="hero-body">
                <div class="container has-text-centered">
                    <h1 class="title">{{ blogTitle() }}</h1>
                </div>
            </div>
        </section>

        <div class="container is-fluid bottom-header">
            <div v-if="post" class="breadcrumbs-parent">
                <ul>
                    <li><router-link to="/blog">Blog</router-link></li>
                    <li><router-link :to="categorySlugLink()">{{ capitalize(post.category.name)}}</router-link></li>
                    <li v-text="capitalize( blogTitle() )"></li>
                </ul>
            </div>
            <app-mail-categories-sticky :items="postsCategories"></app-mail-categories-sticky>
        </div>
        <div class="container is-fluid">
            <section class="articles" v-if="!!post">
                <!-- <scrolly class="scroll-me"> -->
                    <!-- <scrolly-viewport> -->
                        <div class="card article shadowing">
                            <div class="card-content">
                                <div class="content1 article-body" v-html="post.content">
                                </div>
                            </div>
                        </div>
                    <!-- </scrolly-viewport> -->
                    <!-- <scrolly-bar axis="y"></scrolly-bar> -->
                <!-- </scrolly> -->
            </section>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Scrolly, ScrollyViewport, ScrollyBar } from 'vue-scrolly';
import { ApiHome } from '../../.env';
import StringsMixin from '../../mixins/StringsMixin';
import HeaderBar from '../../components/layout/HeaderBar.vue';
import BackButton from '../../components/layout/BackButton.vue';
import MoreButton from '../../components/layout/MoreButton.vue';
import Silentbox from '../../components/elements/silentbox/Silentbox.vue';
import MailCategoriesSticky from '../../components/layout/MailCategoriesSticky.vue';

export default {
    props: ['categorySlug', 'postSlug'],
    mixins: [StringsMixin],

    data() {
        // console.log('Post properties: ', this.categorySlug, this.postSlug)
        return {
            endpoint: ApiHome+ 'post/'+  this.postSlug,
            endpointCategory: ApiHome+ '/'+ this.categorySlug,
            query: '',
            errorClass: '',
            currentTag: null,
            selectedTags:[],
            tags: ['links', 'categories']
        }
    },

    components: {
        'app-header': HeaderBar,
        'app-sb': Silentbox,
        'app-back': BackButton,
        'app-centered-button': MoreButton,
        'app-mail-categories-sticky': MailCategoriesSticky,
        Scrolly,
        ScrollyViewport,
        ScrollyBar
    },

    computed: {
        ...mapGetters([
            'items',
            'post',
            'postsCategories',
            'postsLinks',
            'loading',
            'error',
            'title',
        ]),
    },

    methods: {
        fetchPost() {
            this.$store.dispatch('fetchPost', this.endpoint );
        },

        postDate(post) {
            if(post.updated === '') {
                return post.created;
            }
            return post.updated;
        },

        blogTitle() {
            if(this.title !== '') {
                // console.log('title: ', this.title);
                return this.title;
            }
            // console.log('title empty');
            // return 'Blog o nemških ovčarjih, o Tesi, Oli, Lučki in Figaru, našemu mačku';
        },

        categorySlugLink() {
            return '/blog/' + this.categorySlug;
        }
    },

    created() {
        this.fetchPost();
        // console.log('Blog - Component mounted.')
    }
}
</script>


<style lang="scss">
@import "../../style/variables.scss";
@import "../../style/blog.scss";

</style>


// WEBPACK FOOTER //
// src/views/blog/BlogPost.vue